"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImporterOptions = void 0;
var enums_1 = require("../../core/formats/utils/enums");
var log_1 = require("../../core/rich-utils/debug/logger/base-logger/log");
var ImporterOptions = (function () {
    function ImporterOptions(throwInvalidFile) {
        if (throwInvalidFile === void 0) { throwInvalidFile = function (reason) { if (log_1.Log.isDebug)
            console.log("LoadedFileIsIncorrect: " + reason); }; }
        this.invalidDocumentMode = enums_1.InvalidDocumentMode.OpenAnyway;
        this.allowIntPercentage = false;
        this.createEmptyDocumentOnLoadError = true;
        this.ignoreDeletedText = true;
        this.ignoreInsertedText = true;
        this.ignoreComments = true;
        this.throwInvalidFile = throwInvalidFile;
    }
    return ImporterOptions;
}());
exports.ImporterOptions = ImporterOptions;
